import { Component, OnInit } from "@angular/core";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { RecipientDto } from "../../dto";
import { UtilService } from "../../util.service";
import { catchError } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { HttpRecipientService } from "../../http-recipient.service";


@Component({
	selector: 'app-invoice-list',
	templateUrl: './recipient-list.component.html',
	styleUrls: ['./recipient-list.component.scss']
})
export class RecipientListComponent implements OnInit {
	recipients: RecipientDto[];
	util = UtilService;

	constructor(
		private httpService: HttpRecipientService, 
		private spinner: NgxSpinnerService,
		private toastService: AppToastService,
		private router: Router) {
	}

	ngOnInit(): void {
		this.fetchAllRecipients();
	}

	private fetchAllRecipients() {
		this.spinner.show();
		this.httpService.getAll()
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error fetching recipient', error);
				this.toastService.showDanger({ content: 'Failed to fetch data: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(items => {
			this.recipients = items;
			this.spinner.hide();
		});
	}

	viewRecipient(recipient: RecipientDto) {
		
	}
}